import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { UserDetailsModel } from "@tCooneyBrothers/ApiModels";
import { getUserDetails } from "@tCooneyBrothers/Services/UserDetailsService";
import { CustomHandlerWithResult } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomHandlerWithResult<
    {},
    {
        apiResult: UserDetailsModel[];
    },
    {}
>;

export const DispatchBeginLoadUserDetails: HandlerType = props => {
    props.dispatch({
        type: "Data/UserDetails/BeginLoadUserDetails",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.result = {
        apiResult: await getUserDetails(),
    };
};

export const DispatchCompleteLoadUserDetails: HandlerType = props => {
    props.dispatch({
        type: "Data/UserDetails/CompleteLoadUserDetails",
        result: props.result.apiResult || [],
    });
};

export const chain = [DispatchBeginLoadUserDetails, RequestDataFromApi, DispatchCompleteLoadUserDetails];

const loadUserDetails = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadUserDetails");
export default loadUserDetails;
